// libs
import React, { memo } from 'react';
import { css as _css } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

import { BASE_GUTTER_SPACE, COLORS } from 'shared/styles/base';

// styles
const line = _css`
    background: ${COLORS.PLACEHOLDER};
    height: 11px;
    margin: ${BASE_GUTTER_SPACE}px;
`;

const Container = styled.div<{ showSizes: boolean }>`
  .p-img {
    width: 100%;
    padding-top: 133.334%;
    background: #f4f4f4;
  }

  .p-title {
    ${line}

    height: 12px;
    margin-top: ${({ theme }) => theme.spacing.spacing60};
    width: 30%;
  }

  .p-subTitle {
    ${line}

    height: 10px;
    width: 80%;
  }

  .p-line3 {
    ${line}

    width: 25%;

    ${({ showSizes }) => showSizes === false && `margin-bottom: 9px;`}
  }

  .p-line4 {
    ${line}

    margin-bottom: ${({ theme }) => theme.spacing.spacing50};
    width: 55%;
  }

  .p-color-options {
    height: 20px;
  }
  .p-line-bp {
    background: ${({ theme }) => theme.colors.surface20};
    margin: ${({ theme }) => `${theme.spacing.spacing20} ${theme.spacing.spacing40} 0`};
    height: 16px;
    width: 60%;
  }
`;

interface IPlaceholderProps {
  className?: string;
  showSizes?: boolean;
  showPriceReveal?: boolean;
  showColorOptions?: boolean;
  isBestPriceEnabled?: boolean;
}

function Placeholder({
  className = '',
  showSizes = true,
  showPriceReveal = false,
  showColorOptions = false,
  isBestPriceEnabled,
}: IPlaceholderProps) {
  return (
    <Container className={className} showSizes={showSizes}>
      <div className="p-img" />
      <div className="p-title" />
      <div className="p-subTitle" />
      <div className="p-line3" />

      {isBestPriceEnabled && <div className="p-line-bp" />}
      {showPriceReveal && (
        <>
          <div className="p-title" />
          <div className="p-line3" />
        </>
      )}
      {showSizes && <div className="p-line4" />}
      {showColorOptions && <div className="p-color-options"></div>}
    </Container>
  );
}

export default memo(Placeholder);
